
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftLeft0 as ObiThreewayAcuatorGenericInleftLeft0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-left-0.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftLeft0 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-left-0',
   elementClass: ObiThreewayAcuatorGenericInleftLeft0Element,
   events: {
     
   }
  });
 
 